var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.proposals.length > 0)?_c('div',{staticClass:"buttons-slider"},[_c('swiper',{ref:"swiperNavbarRef",attrs:{"options":_vm.swiperOption}},_vm._l((_vm.proposals),function(link,index){return _c('swiper-slide',{key:index,ref:_vm.swiperNavbarRef,refInFor:true},[_c('ProposalButtonLink',{attrs:{"proposal":link}})],1)}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }